/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Stop } from './Stop';
import {
    StopFromJSON,
    StopFromJSONTyped,
    StopToJSON,
    StopToJSONTyped,
} from './Stop';

/**
 * 
 * @export
 * @interface SearchStops200ResponseResultsInner
 */
export interface SearchStops200ResponseResultsInner {
    /**
     * 
     * @type {Stop}
     * @memberof SearchStops200ResponseResultsInner
     */
    entity?: Stop;
    /**
     * Relevance score (0-1)
     * @type {number}
     * @memberof SearchStops200ResponseResultsInner
     */
    score?: number;
    /**
     * Fields that matched the search query
     * @type {Array<string>}
     * @memberof SearchStops200ResponseResultsInner
     */
    matchedFields?: Array<string>;
    /**
     * Highlighted excerpts from matched fields
     * @type {{ [key: string]: string; }}
     * @memberof SearchStops200ResponseResultsInner
     */
    highlights?: { [key: string]: string; };
}

/**
 * Check if a given object implements the SearchStops200ResponseResultsInner interface.
 */
export function instanceOfSearchStops200ResponseResultsInner(value: object): value is SearchStops200ResponseResultsInner {
    return true;
}

export function SearchStops200ResponseResultsInnerFromJSON(json: any): SearchStops200ResponseResultsInner {
    return SearchStops200ResponseResultsInnerFromJSONTyped(json, false);
}

export function SearchStops200ResponseResultsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchStops200ResponseResultsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'entity': json['entity'] == null ? undefined : StopFromJSON(json['entity']),
        'score': json['score'] == null ? undefined : json['score'],
        'matchedFields': json['matchedFields'] == null ? undefined : json['matchedFields'],
        'highlights': json['highlights'] == null ? undefined : json['highlights'],
    };
}

  export function SearchStops200ResponseResultsInnerToJSON(json: any): SearchStops200ResponseResultsInner {
      return SearchStops200ResponseResultsInnerToJSONTyped(json, false);
  }

  export function SearchStops200ResponseResultsInnerToJSONTyped(value?: SearchStops200ResponseResultsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entity': StopToJSON(value['entity']),
        'score': value['score'],
        'matchedFields': value['matchedFields'],
        'highlights': value['highlights'],
    };
}

